namespace Areas.Dialogs.EditAccountCIBCost {
    "use strict";

    export class Keys {
        static readonly p0Key = "P0";
        static readonly p1Key = "P1";
        static readonly p2Key = "P2";
        static readonly p3Key = "P3";
        static readonly p8Key = "P8";
        static readonly p8iKey = "P8i";
        static readonly p9Key = "P9";

        static readonly subTotalKey = "SubTotal";
        static readonly pwcTotalKey = "PWCTotal";
        static readonly projectTotalKey = "ProjectTotal";
        static readonly grandTotalKey = "GrandTotal";
        static readonly proposedASFKey = "ProposedASF";
        static readonly currentASFKey = "CurrentASF";
        static readonly currentOGSFKey = "CurrentOGSF";

        static readonly ASFGSFRatioKey = "ASFGSFRatio";
        static readonly BuildingCostGSFRatioKey = "BuildingCostGSFRatio";
        static readonly BuildingCostASFRatioKey = "BuildingCostASFRatio";
        static readonly PWCGSFRatioKey = "PWCGSFRatio";
        static readonly PWCASFRatioKey = "PWCASFRatio";
        static readonly P2P3ASFRatioKey = "P2P3ASFRatio";

        static readonly totalKeys = [this.subTotalKey, this.pwcTotalKey, this.projectTotalKey, this.grandTotalKey];
        static readonly analyticalKeys = [this.ASFGSFRatioKey, this.BuildingCostGSFRatioKey,
            this.BuildingCostASFRatioKey, this.PWCGSFRatioKey, this.PWCASFRatioKey, this.P2P3ASFRatioKey];

        static readonly calculatedKeys = this.totalKeys.concat(this.analyticalKeys);

        constructor() {
        }

    }

    export class Indices {
        readonly keysAndDescriptions = {} as IDictionary;

        readonly p0Index: number;
        readonly p1Index: number;
        readonly p2Index: number;
        readonly p3Index: number;
        readonly p8Index: number;
        readonly p8iIndex: number;
        readonly p9Index: number;
        readonly subTotalIndex: number;
        readonly pwcTotalIndex: number;
        readonly projectTotalIndex: number;
        readonly grandTotalIndex: number;
        readonly proposedASFIndex: number;
        readonly currentASFIndex: number;
        readonly currentOGSFIndex: number;
        readonly ASFGSFRatioIndex: number;
        readonly BuildingCostGSFRatioIndex: number;
        readonly BuildingCostASFRatioIndex: number;
        readonly PWCGSFRatioIndex: number;
        readonly PWCASFRatioIndex: number;
        readonly P2P3ASFRatioIndex: number;

        constructor() {
            this.buildKeysAndDescriptions();

            this.p0Index = this.getIndex(Keys.p0Key);
            this.p1Index = this.getIndex(Keys.p1Key);
            this.p2Index = this.getIndex(Keys.p2Key);
            this.p3Index = this.getIndex(Keys.p3Key);
            this.p8Index = this.getIndex(Keys.p8Key);
            this.p8iIndex = this.getIndex(Keys.p8iKey);
            this.p9Index = this.getIndex(Keys.p9Key);

            this.subTotalIndex = this.getIndex(Keys.subTotalKey);
            this.pwcTotalIndex = this.getIndex(Keys.pwcTotalKey);
            this.projectTotalIndex = this.getIndex(Keys.projectTotalKey);
            this.grandTotalIndex = this.getIndex(Keys.grandTotalKey);

            this.proposedASFIndex = this.getIndex(Keys.proposedASFKey);
            this.currentASFIndex = this.getIndex(Keys.currentASFKey);
            this.currentOGSFIndex = this.getIndex(Keys.currentOGSFKey);

            this.ASFGSFRatioIndex = this.getIndex(Keys.ASFGSFRatioKey);
            this.BuildingCostGSFRatioIndex = this.getIndex(Keys.BuildingCostGSFRatioKey);
            this.BuildingCostASFRatioIndex = this.getIndex(Keys.BuildingCostASFRatioKey);
            this.PWCGSFRatioIndex = this.getIndex(Keys.PWCGSFRatioKey);
            this.PWCASFRatioIndex = this.getIndex(Keys.PWCASFRatioKey);
            this.P2P3ASFRatioIndex = this.getIndex(Keys.P2P3ASFRatioKey);
        }

        private buildKeysAndDescriptions() {
            this.keysAndDescriptions["Name"] = "Name";
            this.keysAndDescriptions["P0"] = "P0-Site Clearance";
            this.keysAndDescriptions["P1"] = "P1-Building";
            this.keysAndDescriptions["P2"] = "P2-Exterior Utilities";
            this.keysAndDescriptions["P4"] = "P4-Site Development";
            this.keysAndDescriptions["P5"] = "P5-A&E Fees";
            this.keysAndDescriptions["P6"] = "P6-Campus Administration";
            this.keysAndDescriptions["P7"] = "P7-Survey, Tests, Plans, Specifications";
            this.keysAndDescriptions["P8"] = "P8-Special Items (excluding IDC)";
            this.keysAndDescriptions["SubTotal"] = "Subtotal";
            this.keysAndDescriptions["P9"] = "P9-Contingency";
            this.keysAndDescriptions["PWCTotal"] = "Total (P-W-C)";
            this.keysAndDescriptions["P3"] = "P3-Group 2 & 3 Equipment";
            this.keysAndDescriptions["ProjectTotal"] = "Project Total";
            this.keysAndDescriptions["P8i"] = "P8i-Interest";
            this.keysAndDescriptions["GrandTotal"] = "Grand Total";
            this.keysAndDescriptions["ProposedASF"] = "Proposed ASF";
            this.keysAndDescriptions["CurrentASF"] = "Current ASF";
            this.keysAndDescriptions["CurrentOGSF"] = "Current OGSF";
            this.keysAndDescriptions["ASFGSFRatio"] = "Efficiency Ratio (ASF/GSF)";
            this.keysAndDescriptions["BuildingCostGSFRatio"] = "Building Cost/GSF";
            this.keysAndDescriptions["BuildingCostASFRatio"] = "Building Cost/ASF";
            this.keysAndDescriptions["PWCGSFRatio"] = "P-W-C Cost/GSF";
            this.keysAndDescriptions["PWCASFRatio"] = "P-W-C Cost/ASF";
            this.keysAndDescriptions["P2P3ASFRatio"] = "Group 2 & 3 Cost/ASF";
        }

        private getIndex(searchKey: string) : number {
            let index = 0;

            for (let key in this.keysAndDescriptions) {
                if (searchKey == key) {
                return index;
                } else {
                    index++;
                }
            }
        }
    }

    export class TransformData {

        constructor() {
            
        }

        execute(data:any, keysAndDescriptions: IDictionary) {
            const transformedData = [];

            for (let key in keysAndDescriptions) {
                let description = keysAndDescriptions[key];

                if (!Keys.analyticalKeys.includes(key)) {
                    transformedData.push(
                        {
                            "key": key,
                            "description": description,
                            "c1": data["c1" + key],
                            "c2": data["c2" + key],
                            "c3": data["c3" + key]
                        }
                    );
                } else {
                    transformedData.push(this.calculateAnalytic(data, key, description));
                };
            }

            return transformedData;
        }

        calculateAnalytic(data: any, key: string, description: string) {
            let c1Value = 0;
            let c2Value = 0;
            let c3Value = 0;
            let result: any = {};

            switch (key) {
                case Keys.ASFGSFRatioKey:
                    c1Value = this.getASFGSFRatio(data, "c1");
                    c2Value = this.getASFGSFRatio(data, "c2");
                    c3Value = this.getASFGSFRatio(data, "c3");
                    break;

                case Keys.BuildingCostGSFRatioKey:
                    c1Value = this.getBuildingCostGSFRatio(data, "c1");
                    c2Value = this.getBuildingCostGSFRatio(data, "c2");
                    c3Value = this.getBuildingCostGSFRatio(data, "c3");
                    break;

                case Keys.BuildingCostASFRatioKey:
                    c1Value = this.getBuildingCostASFRatio(data, "c1");
                    c2Value = this.getBuildingCostASFRatio(data, "c2");
                    c3Value = this.getBuildingCostASFRatio(data, "c3");
                    break;

                case Keys.PWCGSFRatioKey:
                    c1Value = this.getPWCGSFRatio(data, "c1");
                    c2Value = this.getPWCGSFRatio(data, "c2");
                    c3Value = this.getPWCGSFRatio(data, "c3");
                    break;

                case Keys.PWCASFRatioKey:
                    c1Value = this.getPWCASFRatio(data, "c1");
                    c2Value = this.getPWCASFRatio(data, "c2");
                    c3Value = this.getPWCASFRatio(data, "c3");
                    break;

                case Keys.P2P3ASFRatioKey:
                    c1Value = this.getP2P3ASFRatio(data, "c1");
                    c2Value = this.getP2P3ASFRatio(data, "c2");
                    c3Value = this.getP2P3ASFRatio(data, "c3");
                    break;
                default:
                    break;
            }

            result.key = key;
            result.description = description;
            result.c1 = c1Value;
            result.c2 = c2Value;
            result.c3 = c3Value;

            return  result;
        }

        getASFGSFRatio(data: any, prefix: string) {
            return this.getRatio(data, Keys.proposedASFKey, Keys.currentOGSFKey, prefix);
        }

        getBuildingCostGSFRatio(data: any, prefix: string) {
            return this.getRatio(data, Keys.p1Key, Keys.currentOGSFKey, prefix);
        }

        getBuildingCostASFRatio(data: any, prefix: string) {
            return this.getRatio(data, Keys.p1Key, Keys.currentASFKey, prefix);
        }

        getPWCGSFRatio(data: any, prefix: string) {
            return this.getRatio(data, Keys.pwcTotalKey, Keys.currentOGSFKey, prefix);
        }

        getPWCASFRatio(data: any, prefix: string) {
            return this.getRatio(data, Keys.pwcTotalKey, Keys.currentASFKey, prefix);
        }

        getP2P3ASFRatio(data: any, prefix: string) {
            return this.getRatio2(data, [Keys.p2Key, Keys.p3Key], Keys.currentASFKey, prefix);
        }

        getRatio(data: any, numerator: string, denominator:string, prefix: string) {
            return data[prefix+denominator] != 0 ? (data[prefix+numerator]) / data[prefix+denominator] : 0;
        }

        getRatio2(data: any, numeratorArray: string[], denominator: any, prefix: string) {
            let num = numeratorArray
                .map(key => Number(data[prefix+key]))
                .reduce((total, current) => { return total + current; }, 0);

            return data[prefix+denominator] != 0 ? num / data[prefix+denominator] : 0;
        }
    }
}
